import styled from '@emotion/styled';
import { breakpoints, mediaQuery, colorVariables, fontSizes, fontWeights, gutterSizes, boxSizes } from '../base/theme';
import Dialog from '../dialog/dialog';
import Button from '../button/button';

export const StyledSubmitResultDialog = styled(Dialog)`
    padding: 0;
    border-radius: ${boxSizes.borderRadius8};
    display: flex;
    flex-wrap: wrap;

    .dialog-container {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
    }

    .dialog {
        min-width: auto;
        width: 60%;
        padding: 0;
        border-radius: ${boxSizes.borderRadius8};
        position: relative;

        ${mediaQuery.until(breakpoints.small)} {
            width: 100%;
            position: fixed;
            border-bottom-left-radius: 0px;
            border-bottom-right-radius: 0px;
        }
    }

    .dialog-content {
        width: 100%;
        padding: ${gutterSizes.large40} ${gutterSizes.xlarge};
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;

        h2 {
            font-size: ${fontSizes.xlarge};
        }
    }

    .dialog-close {
        position: absolute;
        top: ${gutterSizes.base};
        right: ${gutterSizes.base};
        background: none;
        border: none;
        padding: ${gutterSizes.base};
        cursor: pointer;
        border-radius: ${boxSizes.borderRadius4};
        display: flex;
        align-items: center;
        justify-content: center;

        &:hover {
            background-color: ${colorVariables.backgroundLight};
        }

        &:focus {
            outline: 2px solid ${colorVariables.textLink};
            outline-offset: 2px;
        }
    }
`;

export const ImageContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: ${gutterSizes.xlarge};
    
    img {
        height: 128px;
        width: auto;
    }
`;

export const Title = styled.h2`
    font-size: ${fontSizes.pgLarge};
    font-weight: ${fontWeights.bold};
    color: ${colorVariables.textPrimary};
    margin-bottom: ${gutterSizes.base};
    line-height: 1.3;
    white-space: pre-line;
`;

export const Description = styled.p`
    font-size: ${fontSizes.base};
    font-weight: ${fontWeights.normal};
    color: ${colorVariables.textSecondary};
    margin-bottom: ${gutterSizes.xlarge};
    margin-top: 0;
    line-height: 1.4;
    white-space: pre-line;
`;

export const ButtonsContainer = styled.div`
    display: flex;
    width: 100%;
    gap: ${gutterSizes.base};
`;

export const ActionButton = styled(Button)`
    flex: 1;
    justify-content: center;
    font-weight: ${fontWeights.bold};
    border-radius: ${boxSizes.borderRadius4};
`;
